'use client';

import { useCallback, useEffect } from 'react';
import { doc, serverTimestamp, setDoc, getDoc } from 'firebase/firestore';

import { useAuthStore } from '@/slw/shared/stores/auth.store';
import { useUserProfile } from '@/slw/entities/profile/profile-query';
import { isLoggedInClient } from '@/slw/shared/lib/auth.client';
import { db } from '@/slw/shared/lib/firebase/config';
import { requestNotificationsPermissions } from '@/slw/shared/lib/firebase/utils';

export function AuthProvider() {
  const setUser = useAuthStore((state) => state.setUser);
  const setOnlineStatus = useAuthStore((state) => state.setOnlineStatus);

  const { data: userProfile } = useUserProfile(isLoggedInClient());

  const loadUserData = useCallback(async () => {
    if (userProfile?.data?.id) {
      setUser(userProfile.data);
      await setDoc(
        doc(db, 'users', userProfile.data.id!),
        {
          username: `${userProfile.data.firstName || ''} ${userProfile.data.lastName || ''}` || '',
          email: userProfile.data.email || '',
          avatar: userProfile.data.avatar || null,
          id: userProfile.data.id,
          phoneNumber: userProfile.data.phoneNumber,
          lastSeen: serverTimestamp(),
        },
        { merge: true },
      );
      // Kiểm tra xem userchats đã tồn tại chưa
      const userChatsRef = doc(db, 'userchats', userProfile.data.id!);
      const userChatsSnap = await getDoc(userChatsRef);

      // Chỉ tạo mới nếu chưa tồn tại
      if (!userChatsSnap.exists()) {
        await setDoc(userChatsRef, {
          chats: [],
        });
      }

      // Thiết lập trạng thái online cho người dùng
      setOnlineStatus(userProfile.data.id!);
    }
  }, [setUser, setOnlineStatus, userProfile?.data]);

  useEffect(() => {
    requestNotificationsPermissions();

    loadUserData();
  }, [loadUserData, setUser, userProfile]);

  return null;
}
